<!-- yf.vue -->
<template>
	<div class="xyk-container">
		<!-- 筛选条件区域 -->
		<div class="filter-section">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item label="药品名称：">
					<el-input v-model="filterForm.drugName" placeholder="请输入药品名称" size="small" clearable
						style="width: 200px;" prefix-icon="el-icon-Ssearch" />
				</el-form-item>

				<el-form-item label="药品剂型：">
					<el-select v-model="filterForm.dosform" placeholder="请选择药品剂型" size="small" clearable
						style="width: 150px;">
						<el-option label="全部剂型" value=""></el-option>
						<el-option label="片剂" value="片剂"></el-option>
						<el-option label="胶囊" value="胶囊"></el-option>
						<el-option label="注射液" value="注射液"></el-option>
						<el-option label="颗粒剂" value="颗粒剂"></el-option>
						<el-option label="软膏" value="软膏"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-checkbox v-model="filterForm.isHaveNum" style="margin-left: 10px;"
						@change="handleStockFilterChange">
						仅显示有库存
					</el-checkbox>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" size="small" @click="handleFilter" icon="el-icon-Ssearch">
						查询
					</el-button>
					<el-button size="small" @click="resetFilter">
						重置
					</el-button>
				</el-form-item>
			</el-form>
		</div>

		<!-- 统计信息区域 -->
		<div class="stats-section">
			<el-tabs v-model="statsActiveTab" type="border-card" @tab-click="handleStatsTabClick" class="stats-tabs">
				<el-tab-pane label="库存明细表" name="detail" class="stats-tab-pane">
					<!-- 库存明细表内容 -->
					<div class="stats-content">
						<!-- 主表格和批次表格容器 -->
						<div class="table-container-wrapper">
							<!-- 主表格 -->
							<div class="main-table-section">
								<div class="table-section">
									<!-- 主表格 header 已移除 -->

									<div class="table-container" ref="mainTableContainer">
										<el-table :data="tableData" ref="singleTable" border stripe
											@row-dblclick="handledbRow" highlight-current-row
											@current-change="handleCurrentTableChange" v-loading="loading"
											style="width: 100%;" :height="tableHeight" :key="tableKey"
											:row-class-name="getRowClassName">

											<!-- ===== 固定列：行号 ===== -->
											<el-table-column fixed="left" label="行号" type="index" width="50"
												align="center"></el-table-column>

											<!-- ===== 药品类型 ===== -->
											<el-table-column prop="drugType" label="药品类型" width="80" align="center">
												<template slot-scope="scope">
													<el-tag :type="getDrugTypeTagType(scope.row.drugType)" size="mini">
														{{ statusMap[scope.row.drugType] }}
													</el-tag>
												</template>
											</el-table-column>

											<!-- ===== 药品名称 ===== -->
											<el-table-column prop="drugName" label="药品名称" min-width="150"
												show-overflow-tooltip></el-table-column>

											<!-- ===== 药品编码 ===== -->
											<el-table-column prop="code" label="药品编码" min-width="120"
												show-overflow-tooltip></el-table-column>
											<!-- ===== 规格描述（加宽） ===== -->
											<el-table-column prop="drugSpec" label="规格描述" min-width="260"
												show-overflow-tooltip></el-table-column>

											<!-- ===== 包装规格 ===== -->
											<el-table-column prop="pacSpec" label="包装规格" min-width="120"
												show-overflow-tooltip></el-table-column>

											<!-- ===== 成本总金额 ===== -->
											<el-table-column prop="purcAmt" label="成本总金额" width="120" align="right">
												<template slot-scope="scope">
													¥{{ scope.row.purcAmt ? formatDecimal(scope.row.purcAmt, 2) : '0.00' }}
												</template>
											</el-table-column>

											<!-- ===== 销售总金额 ===== -->
											<el-table-column prop="saleAmt" label="销售总金额" width="120" align="right">
												<template slot-scope="scope">
													¥{{ scope.row.saleAmt ? formatDecimal(scope.row.saleAmt, 2) : '0.00' }}
												</template>
											</el-table-column>

											<!-- ===== 实际库存数量 ===== -->
											<el-table-column prop="realPurcCnt" label="实际库存数量" width="120"
												align="center"></el-table-column>

											<!-- ===== 冻结库存数量 ===== -->
											<el-table-column prop="freezePurcCnt" label="冻结库存数量" width="120"
												align="center"></el-table-column>

											<!-- ===== 操作列 ===== -->
											<el-table-column fixed="right" label="操作" width="90" align="center">
												<template slot-scope="scope">
													<el-button type="text" size="mini"
														@click="handleBatchDetail(scope.row)">
														批次明细
													</el-button>
												</template>
											</el-table-column>
										</el-table>
									</div>

									<!-- 分页 -->
									<div class="pagination-section">
										<el-pagination @size-change="handleSizeChange"
											@current-change="handleCurrentChange" :current-page="pageNum"
											:page-sizes="[20, 50, 100, 200]" :page-size="pageSize" :total="totalSize"
											layout="total, sizes, prev, pager, next, jumper" background>
										</el-pagination>
									</div>
								</div>
							</div>

							<!-- 批次明细表格（绝对定位覆盖主表格，仅位移动画，无透明度/模糊） -->
							<div class="batch-table-section" :class="{ 'expanded': batchDetailVisible }">
								<!-- 圆形右箭头：位于最左侧、竖向 Y 轴正中间，点击向右缓慢滑出关闭 -->
								<div class="batch-toggle-btn" title="收起批次明细" @click="closeBatchDetail">
									<i class="el-icon-arrow-right"></i>
								</div>

								<div class="batch-table-header">
									<div class="batch-table-title">
										<span>批次明细 - {{ currentBatchDrugName }}</span>
									</div>
								</div>

								<div class="batch-table-container" ref="batchTableContainer">
									<el-table :data="batchDetailData" v-loading="batchLoading" border stripe
										:height="batchTableHeight" style="width: 100%;"
										:row-class-name="getRowClassName">

										<el-table-column fixed="left" label="行号" type="index" width="50"
											align="center"></el-table-column>
										<el-table-column prop="drugName" label="药品名称" width="150"
											show-overflow-tooltip></el-table-column>
										<el-table-column prop="purcCnt" label="库存数量" width="90"
											align="center"></el-table-column>
										<el-table-column prop="manuDate" label="生产日期" width="110"
											align="center"></el-table-column>
										<el-table-column prop="expyDate" label="有效期至" width="110"
											align="center"></el-table-column>
										<el-table-column prop="manuLotnum" label="生产批号" width="110"
											align="center" show-overflow-tooltip></el-table-column>
										<el-table-column prop="prodentpName" label="生产厂家" width="150"
											show-overflow-tooltip></el-table-column>
										<el-table-column prop="supplierName" label="供货单位" width="120"
											align="center" show-overflow-tooltip></el-table-column>

										<el-table-column prop="purcAmt" label="成本总价" width="100" align="right">
											<template slot-scope="scope">
												¥{{ scope.row.purcAmt || '0.00' }}
											</template>
										</el-table-column>
										<el-table-column prop="saleAmt" label="零售总价" width="100" align="right">
											<template slot-scope="scope">
												¥{{ scope.row.saleAmt || '0.00' }}
											</template>
										</el-table-column>

										<!-- 操作列：宽度保持 280，仅保留流向记录（primary + 图标）与售价调整（hover 下拉含效期调整） -->
										<el-table-column fixed="right" label="操作" width="280" align="center">
											<template slot-scope="scope">
												<el-button type="primary" icon="el-icon-ggml" size="mini"
													@click="handleFlowRecord(scope.row)">
													流向记录
												</el-button>
												<el-dropdown trigger="hover" placement="bottom-end"
													style="margin-left: 8px;"
													@command="handleBatchActionCommand">
													<el-button type="danger" icon="el-icon-down" size="mini"
														@click="handlePriceAdjust(scope.row)">
														成本调整
													</el-button>
													<el-dropdown-menu slot="dropdown">
														<el-dropdown-item
															:command="{ action: 'expiry', row: scope.row }"
															icon="el-icon-date">
															效期调整
														</el-dropdown-item>
													</el-dropdown-menu>
												</el-dropdown>
											</template>
										</el-table-column>
									</el-table>
								</div>

								<!-- 批次分页 -->
								<div class="batch-pagination-section">
									<el-pagination @size-change="handleBatchSizeChange"
										@current-change="handleBatchCurrentChange" :current-page="batchPageNum"
										:page-sizes="[10, 20, 50]" :page-size="batchPageSize" :total="batchTotalSize"
										layout="total, sizes, prev, pager, next, jumper" background small>
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>

				<!-- 价格调整对话框（已移除销售单价，仅保留成本单价） -->
				<el-dialog title="价格调整" :visible.sync="priceAdjustVisible" width="500px" top="10vh"
					:before-close="priceAdjustHandleClose" class="price-adjust-dialog">

					<div class="price-adjust-form">
						<el-form :model="priceAdjustForm" :rules="priceAdjustRules" ref="priceAdjustForm"
							label-width="120px">
							<el-form-item label="药品名称" prop="drugName">
								<el-input v-model="priceAdjustForm.drugName" :disabled="true" />
							</el-form-item>

							<el-form-item label="生产批号" prop="manuLotnum">
								<el-input v-model="priceAdjustForm.manuLotnum" :disabled="true" />
							</el-form-item>

							<el-form-item label="当前库存" prop="realCnt">
								<el-input v-model="priceAdjustForm.realCnt" :disabled="true" />
								<div style="font-size: 12px; color: #909399; margin-top: 4px;">
									格式：包装单位数量 + 最小单位数量
								</div>
							</el-form-item>

							<el-form-item label="调整成本单价" prop="adjustPurcPric" required>
								<div style="display: flex; align-items: center;">
									<el-input-number v-model="priceAdjustForm.adjustPurcPric" :min="0" :precision="2"
										:step="0.01" style="width: 100%;" />
								</div>
								<div v-if="priceAdjustForm.adjustPurcPric > 0"
									style="font-size: 12px; color: #67C23A; margin-top: 4px;">
									调整后成本总价：¥{{ (priceAdjustForm.adjustPurcPric * getPackageCount(priceAdjustForm.realCnt)).toFixed(2) }}
								</div>
								<div style="font-size: 16px; color: brown; margin-top: 4px;font-weight: bold;">
									注意：默认均以最小单位价格存储！
								</div>
							</el-form-item>
						</el-form>
					</div>

					<span slot="footer" class="dialog-footer">
						<el-button size="small" @click="priceAdjustVisible = false">取消</el-button>
						<el-button size="small" type="primary" @click="handlePriceAdjustSubmit">确定</el-button>
					</span>
				</el-dialog>

				<!-- 效期调整对话框 -->
				<el-dialog title="效期调整" :visible.sync="expiryAdjustVisible" width="500px" top="10vh"
					:before-close="expiryAdjustHandleClose" class="expiry-adjust-dialog">

					<div class="expiry-adjust-form">
						<el-form :model="expiryAdjustForm" :rules="expiryAdjustRules" ref="expiryAdjustForm"
							label-width="100px">
							<el-form-item label="药品名称" prop="drugName">
								<el-input v-model="expiryAdjustForm.drugName" :disabled="true" />
							</el-form-item>

							<el-form-item label="生产批号" prop="manuLotnum">
								<el-input v-model="expiryAdjustForm.manuLotnum" :disabled="true" />
							</el-form-item>

							<el-form-item label="生产日期" prop="manuDate">
								<el-date-picker v-model="expiryAdjustForm.manuDate" type="date" placeholder="选择生产日期"
									value-format="yyyy-MM-dd" style="width: 100%;" disabled />
							</el-form-item>

							<el-form-item label="有效期至" prop="expyDate">
								<el-date-picker v-model="expiryAdjustForm.expyDate" type="date" placeholder="选择有效期至"
									value-format="yyyy-MM-dd" style="width: 100%;" />
							</el-form-item>
						</el-form>
					</div>

					<span slot="footer" class="dialog-footer">
						<el-button size="small" @click="expiryAdjustVisible = false">取消</el-button>
						<el-button size="small" type="primary" @click="handleExpiryAdjustSubmit">确定</el-button>
					</span>
				</el-dialog>

				<el-tab-pane label="库存预警" name="warning" :disabled="true">
					<!-- 库存预警内容 -->
					<div class="stats-content">
						<div class="table-section">
							<div class="warning-filter">
								<el-form :inline="true" :model="warningFilterForm" size="small">
									<el-form-item label="库房名称：">
										<el-select v-model="warningFilterForm.shedName" placeholder="请选择"
											style="width: 120px;">
											<el-option label="西药库" value="西药库"></el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="药品类型：">
										<el-dropdown @command="handleWarningCommand" trigger="click">
											<span class="el-dropdown-link">
												{{ warningDropDownedName }}<i class="el-icon-down"></i>
											</span>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item :command="v.command"
													v-for="(v,i) in warningDropdownMenu" :key="i">
													{{ v.label }}
												</el-dropdown-item>
												<el-dropdown-item command="e" divided>全部</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</el-form-item>

									<el-form-item label="药品名称：">
										<el-input v-model="warningFilterForm.drugName" placeholder="编码、名称、拼音简码"
											style="width: 180px;" suffix-icon="el-icon-key" />
									</el-form-item>

									<el-form-item>
										<el-button type="primary" size="small" @click="handleWarningFilter"
											icon="el-icon-Ssearch">
											查询
										</el-button>
									</el-form-item>
									<div class="warning-buttons">
										<el-button size="small" @click="handleWarningRefresh">
											刷新
										</el-button>
										<el-button type="primary" size="small" @click="handleSetWarning">
											设置预警数量
										</el-button>
									</div>
								</el-form>
							</div>

							<div class="table-container">
								<el-table :data="warningTableData" border highlight-current-row
									v-loading="warningLoading" style="width: 100%;" :height="tableHeight"
									@current-change="handleWarningCurrentChange" :row-class-name="getRowClassName">

									<el-table-column fixed="left" label="行号" type="index" width="50"
										align="center"></el-table-column>

									<el-table-column v-for="(col, inx) in warningTableRows" :key="inx" :type="col.type"
										:prop="col.prop" :label="col.name"
										:width="warningColumnWidth(col, warningTableData)" align="center"
										show-overflow-tooltip>
									</el-table-column>
								</el-table>
							</div>

							<div class="pagination-section">
								<el-pagination @size-change="handleWarningSizeChange"
									@current-change="handleWarningCurrentChange" :current-page="warningPageNum"
									:page-sizes="[20, 50, 100]" :page-size="warningPageSize" :total="warningTotalSize"
									layout="total, sizes, prev, pager, next, jumper" background>
								</el-pagination>
							</div>
						</div>
					</div>
				</el-tab-pane>

				<el-tab-pane label="库存可视化图表" name="chart">
					<div class="stats-content">
						<div class="chart-controls" style="display: flex;justify-content: space-between;">
							<div class="chart-type-selector">
								<el-radio-group v-model="chartType" size="small" @change="updateChart">
									<el-radio-button label="line">折线图</el-radio-button>
									<el-radio-button label="bar">柱状图</el-radio-button>
									<el-radio-button label="pie">饼图</el-radio-button>
									<el-radio-button label="treemap">树图</el-radio-button>
									<el-radio-button label="candlestick">K线图</el-radio-button>
								</el-radio-group>
							</div>

							<div class="chart-options">
								<el-select v-model="chartDataField" size="small" placeholder="选择数据字段"
									@change="updateChart">
									<el-option label="库存数量" value="purcCnt"></el-option>
									<el-option label="成本金额" value="purcAmt"></el-option>
									<el-option label="零售金额" value="saleAmt"></el-option>
									<el-option label="药品类型" value="drugType"></el-option>
								</el-select>

								<el-select v-model="chartGroupBy" size="small" placeholder="分组方式" @change="updateChart">
									<el-option label="按药品类型" value="drugType"></el-option>
									<el-option label="按库房" value="shedId"></el-option>
									<el-option label="按剂型" value="dosform"></el-option>
								</el-select>

								<el-button size="small" icon="el-icon-refresh" @click="refreshChart">刷新</el-button>
								<el-button size="small" icon="el-icon-download" @click="downloadChart">导出</el-button>
							</div>
						</div>

						<div class="chart-container">
							<div id="inventoryChart" style="width: 100%; height: 500px;"></div>
						</div>

						<div class="chart-stats">
							<el-row :gutter="20">
								<el-col :span="6">
									<div class="stat-card">
										<div class="stat-title">药品总数</div>
										<div class="stat-value">{{ chartStats.totalDrugs }}</div>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="stat-card">
										<div class="stat-title">库存总量</div>
										<div class="stat-value">{{ chartStats.totalStock }}</div>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="stat-card">
										<div class="stat-title">成本总额</div>
										<div class="stat-value">¥{{ chartStats.totalCost }}</div>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="stat-card">
										<div class="stat-title">平均库存</div>
										<div class="stat-value">{{ chartStats.avgStock }}</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<!-- 流向记录对话框 -->
		<el-dialog :title="'【' + flowDialogTitle + '】' + '药品流向记录'" :visible.sync="flowdiglog" width="70%" top="5vh"
			:before-close="flowhandleClose" class="flow-dialog">

			<div class="dialog-header">
				<span>业务日期:</span>
				<el-date-picker v-model="startDate" type="datetime" size="small" style="margin-left: 8px; width: 180px;"
					placeholder="选择开始时间" :picker-options="pickerOptions" @change="startDateHandle"
					value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
				<el-date-picker v-model="endDate" type="datetime" style="margin-left: 8px; width: 180px;" size="small"
					placeholder="选择结束时间" :picker-options="pickerOptions" @change="endDateHandle"
					value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
				<el-button size="small" type="primary" plain @click="changeData" style="margin-left: 8px;">
					刷新
				</el-button>
			</div>

			<div class="dialog-table">
				<el-table :data="innertableData" v-loading="loading" ref="singleTable" border
					@row-dblclick="handledbRow" highlight-current-row @current-change="handleCurrentTableChange"
					height="400" :row-class-name="getRowClassName">

					<el-table-column prop="id" label="系统序号" width="70" align="center"></el-table-column>
					<el-table-column prop="drugName" label="药品名称" width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="shedId" label="入库库房" width="110" align="center">
						<template slot-scope="{ row }">
							<span>{{ shedIdMap[row.shedId] || '-' }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="bizSouc" label="业务来源" width="110" align="center">
						<template slot-scope="{ row }">
							<span :style="{ color: bizColorMap[row.bizSouc] }">{{ bizMap[row.bizSouc] || '未知' }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="chgCnt" label="库存变化数量" width="140" show-overflow-tooltip></el-table-column>

					<el-table-column v-for="(col, inx) in innertableDataRows" :key="inx" :type="col.type"
						:prop="col.prop" :label="col.name" :width="flowdiglogColumnWidth(col, innertableData)"
						align="center">
					</el-table-column>
				</el-table>
			</div>

			<div class="dialog-pagination">
				<el-pagination @size-change="innerHandleSizeChange" @current-change="innerHandleCurrentChange"
					:current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="innerPageSize"
					:total="innerTotolSize" layout="total, sizes, prev, pager, next, jumper" background size="small">
				</el-pagination>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="dy">打印</el-button>
				<el-button size="small" @click="flowdiglog = false">关闭</el-button>
			</span>
		</el-dialog>

		<!-- 设置预警数量对话框 -->
		<el-dialog title="库存预警编辑[西药]" :visible.sync="warningEditVisible" width="70%" top="5vh"
			:before-close="warningEditHandleClose" class="warning-edit-dialog">

			<div class="warning-edit-table">
				<el-table :data="warningEditTableData" border highlight-current-row v-loading="warningLoading"
					height="400" :cell-class-name="warningTableCellClassName" @row-dblclick="warningEditDbClick"
					:row-class-name="getRowClassName">

					<el-table-column fixed="left" label="行号" type="index" width="50" align="center"></el-table-column>

					<el-table-column prop="shedId" label="入库库房" width="110" align="center">
						<template slot-scope="{ row }">
							<span>{{ shedIdMap[row.shedId] || '-' }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="drugCode" label="药品编码" width="120" align="center"></el-table-column>
					<el-table-column prop="drugName" label="药品名称" width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="drugSpec" label="规格描述" width="180" show-overflow-tooltip></el-table-column>
					<el-table-column prop="prodentpName" label="生产厂家" width="140"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="purcCnt" label="库存数量" width="90" align="center"></el-table-column>
					<el-table-column prop="unit" label="药品单位" width="90" align="center"></el-table-column>

					<el-table-column prop="cntLow" label="最低库存数量" width="120" align="center">
						<template slot-scope="scope">
							<el-input size="mini" v-model="scope.row.cntLow"
								:ref="`warning_${scope.row.index}_${scope.column.index}`"
								v-if="`warning_${scope.row.index}_${scope.column.index}` === warningCurrentCell"
								@blur="warningEditHideInput(scope.row)" placeholder="请输入" />
							<span v-else>{{ scope.row.cntLow }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="cntHigh" label="最高库存数量" width="120" align="center">
						<template slot-scope="scope">
							<el-input size="mini" v-model="scope.row.cntHigh"
								:ref="`warning_${scope.row.index}_${scope.column.index}`"
								v-if="`warning_${scope.row.index}_${scope.column.index}` === warningCurrentCell"
								@blur="warningEditHighHideInput(scope.row)" placeholder="请输入" />
							<span v-else>{{ scope.row.cntHigh }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="repairPurcCnt" label="应补库存数" width="90" align="center"></el-table-column>
					<el-table-column prop="pharmacyCnt" label="药房库存数" width="90" align="center"></el-table-column>
				</el-table>
			</div>

			<div class="warning-edit-pagination">
				<el-pagination @size-change="handleWarningEditSizeChange"
					@current-change="handleWarningEditCurrentChange" :current-page="warningEditPageNum"
					:page-sizes="[10, 20, 50]" :page-size="warningEditPageSize" :total="warningEditTotalSize"
					layout="total, sizes, prev, pager, next, jumper" background size="small">
				</el-pagination>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button :loading="warningLoading" size="small" @click="warningEditVisible = false">取 消</el-button>
				<el-button :loading="warningLoading" size="small" type="primary" @click="warningEditSubmit">确
					定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	// 导入ECharts
	import * as echarts from 'echarts';
	import printUtil from "@/untils/printUtil";
	import {
		Winvent
	} from "@/assets/printTemplateConfig/Winvent";
	import {
		dugdpurctablePage,
		dugYFChgPage
	} from "@/api/MedicenHouse/Western.js";
	import {
		getYFBatchNumber,
		updateDate
	} from "@/api/PSI/DrugInventory.js";
	// 调价相关接口
	import {
		chgYFDetailsPage,
		adjustYFFastPric
	} from "@/api/PSI/ChangeDetailsTable.js";
	// 导入库存预警相关接口
	import {
		alertList,
		alertPages,
		alert
	} from "@/api/PSI/westernWarning.js";
	// 药品剂型相关
	import {
		getDosageForm
	} from "@/api/PSI.js";

	export default {
		name: 'Xyk',
		props: {
			inventoryType: {
				type: String,
				default: 'western'
			}
		},
		computed: {
			// 仅比较成本单价是否发生变化
			isPriceChanged() {
				return this.priceAdjustForm.adjustPurcPric !== this.originalPrices.purcPric;
			},
			// 仅比较成本单价是否未发生变化
			isNoChange() {
				return this.priceAdjustForm.adjustPurcPric === this.originalPrices.purcPric;
			}
		},
		data() {
			return {
				statsActiveTab: 'detail',
				filterForm: {
					drugName: '',
					dosform: '',
					dateRange: [],
					isHaveNum: true
				},
				priceAdjustVisible: false,
				// 已移除 adjustSalePric
				priceAdjustForm: {
					drugName: '',
					manuLotnum: '',
					adjustPurcPric: 0,
					drugId: 0,
					purcId: 0,
					purcType: 1,
					realCnt: '0'
				},
				// 已移除 salePric
				originalPrices: {
					purcPric: 0
				},
				// 已移除 adjustSalePric 校验规则
				priceAdjustRules: {
					adjustPurcPric: [{
							required: true,
							message: '请输入调整成本单价',
							trigger: 'blur'
						},
						{
							type: 'number',
							min: 0,
							message: '成本单价不能为负数',
							trigger: 'blur'
						}
					]
				},
				currentPriceRow: null,
				priceChanged: false,
				totalStock: '0',
				totalInventoryCount: 0,
				totalCost: '0.00',
				currentPageTotalStock: '0',
				tableHeight: 400,
				batchTableHeight: 400,
				pageNum: 1,
				pageSize: 50,
				totalSize: 0,
				tableData: [],
				tableKey: Date.now(),
				expiryAdjustForm: {
					drugName: '',
					manuLotnum: '',
					manuDate: '',
					expyDate: ''
				},
				expiryAdjustRules: {
					manuDate: [{
						required: true,
						message: '请选择生产日期',
						trigger: 'change'
					}],
					expyDate: [{
						required: true,
						message: '请选择有效期至',
						trigger: 'change'
					}]
				},
				currentExpiryRow: null,
				flowdiglog: false,
				batchDetailVisible: false,
				warningEditVisible: false,
				expiryAdjustVisible: false,
				flowDialogTitle: '',
				batchDetailData: [],
				startDate: '',
				endDate: '',
				flowId: '',
				manuLotnum: '',
				loading: false,
				innerPageSize: 10,
				innerTotolSize: 20,
				currentTable: {},
				innertableData: [],
				warningLoading: false,
				warningPageNum: 1,
				warningPageSize: 20,
				warningTotalSize: 0,
				warningTableData: [],
				warningEditTableData: [],
				warningEditPageNum: 1,
				warningEditPageSize: 10,
				warningEditTotalSize: 0,
				warningCurrentCell: null,
				warningSubmitData: {},
				warningFilterForm: {
					shedName: '西药库',
					drugName: ''
				},
				warningDropDownedName: '全部',
				warningDropdownMenu: [{
						id: 1,
						label: '卫材',
						command: 'a'
					},
					{
						id: 2,
						label: '疫苗',
						command: 'b'
					},
					{
						id: 3,
						label: '中成药',
						command: 'c'
					},
					{
						id: 4,
						label: '西药',
						command: 'd'
					}
				],
				warningTableRows: [{
						name: "药品编码",
						prop: "drugCode",
						type: ""
					},
					{
						name: "药品名称",
						prop: "drugName",
						type: ""
					},
					{
						name: "规格描述",
						prop: "drugSpec",
						type: ""
					},
					{
						name: "生产厂家",
						prop: "prodentpName"
					},
					{
						name: "库存数量",
						prop: "purcCnt",
						type: ""
					},
					{
						name: "药品单位",
						prop: "unit"
					},
					{
						name: "最低库存数",
						prop: "cntLow",
						type: ""
					},
					{
						name: "最高库存数",
						prop: "cntHigh",
						type: ""
					},
					{
						name: "应补库存数",
						prop: "repairPurcCnt"
					},
					{
						name: "药房库存数",
						prop: "pharmacyCnt",
						type: ""
					}
				],
				chart: null,
				chartType: 'line',
				chartDataField: 'purcCnt',
				chartGroupBy: 'drugType',
				chartStats: {
					totalDrugs: 0,
					totalStock: 0,
					totalCost: '0.00',
					avgStock: 0
				},
				shedIdMap: {
					1: '药库',
					2: '药房',
				},
				drugTypeMap: {
					1: '西药',
					2: '中药',
					3: '卫材',
					4: '血液',
					5: '疫苗'
				},
				dosformMap: {
					'片剂': '片剂',
					'胶囊': '胶囊',
					'注射液': '注射液',
					'颗粒剂': '颗粒剂',
					'软膏': '软膏'
				},
				// 旧 shedIdMap 保留以兼容其他位置，但主要使用新映射
				oldShedIdMap: {
					1: '西药库',
					2: '中药库',
					3: '西药房',
					4: '中药房'
				},
				bizMap: {
					1: '采购入库',
					2: '其他入库',
					3: '冲销入库',
					4: '调拨出库',
					5: '出库',
					6: '盘点入库',
					7: '盘点反结转入库',
					8: '发药入库',
					9: '退药入库',
					10: '调拨入库',
				},
				bizColorMap: {
					1: '#67C23A',
					2: '#409EFF',
					3: '#F56C6C',
					4: '#FF6700',
					5: '#aa0000',
					6: '#F56C6C',
					7: '#FF6700',
					8: '#67C23A',
					9: '#aa0000'
				},
				statusMap: {
					1: '西药',
					2: '中药',
					3: '卫材',
					4: '血液',
					5: '疫苗'
				},
				currentBatchDrug: null,
				currentBatchDrugName: '',
				batchLoading: false,
				batchPageNum: 1,
				batchPageSize: 10,
				batchTotalSize: 0,
				// tableRows 已删除，改用显式列
				innertableDataRows: [{
						name: "创建时间",
						prop: "createTime",
						type: ""
					},
					{
						name: "变化前库",
						prop: "agoCnt",
						type: ""
					},
					{
						name: "变化后库",
						prop: "afrCnt",
						type: ""
					},
					{
						name: "计量单位",
						prop: "unt",
						type: ""
					},
					{
						name: "成本单价",
						prop: "purcPric",
						type: ""
					},
					{
						name: "零售单价",
						prop: "salePric",
						type: ""
					},
					{
						name: "药品规格",
						prop: "drugSpec",
						type: ""
					},
					{
						name: "生产厂家",
						prop: "prodentpName",
						type: ""
					},
					{
						name: "生产批号",
						prop: "manuLotnum",
						type: ""
					}
				],
				pickerOptions: {
					shortcuts: [{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						},
						{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						},
						{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit('pick', date);
							}
						},
						{
							text: '半年前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 180);
								picker.$emit('pick', date);
							}
						},
						{
							text: '去年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 360);
								picker.$emit('pick', date);
							}
						}
					]
				}
			};
		},
		watch: {
			inventoryType: {
				immediate: true,
				handler(newVal) {
					this.loadData();
				}
			},
			// 已移除 adjustSalePric 的监听
			'priceAdjustForm.adjustPurcPric': function(newVal, oldVal) {
				this.checkPriceChange();
			},
			statsActiveTab: {
				handler(newVal) {
					if (newVal === 'chart') {
						this.$nextTick(() => {
							this.initChart();
							this.updateChart();
						});
					}
				}
			},
			batchDetailVisible() {
				this.$nextTick(() => {
					this.calculateTableHeight();
				});
			}
		},
		mounted() {
			this.loadData();
			this.getDateTime();
			this.calculateTableHeight();
			this.$nextTick(() => {
				window.addEventListener('resize', this.calculateTableHeight);
				setTimeout(() => {
					this.calculateTableHeight();
				}, 300);
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calculateTableHeight);
			if (this.chart) {
				this.chart.dispose();
				this.chart = null;
			}
		},
		methods: {
			// ========== 布局与高度计算 ==========
			calculateTableHeight() {
				this.$nextTick(() => {
					const mainContainer = this.$refs.mainTableContainer;
					if (mainContainer) {
						const height = mainContainer.clientHeight;
						this.tableHeight = Math.max(200, height - 2);
					} else {
						const windowHeight = window.innerHeight;
						const otherHeight = 440;
						this.tableHeight = Math.max(300, windowHeight - otherHeight);
					}

					const batchContainer = this.$refs.batchTableContainer;
					if (batchContainer) {
						const height = batchContainer.clientHeight;
						this.batchTableHeight = Math.max(200, height - 2);
					} else {
						this.batchTableHeight = this.tableHeight;
					}
				});
			},

			// ========== 格式化工具 ==========
			formatDecimal(value, decimals = 2) {
				if (value === null || value === undefined || isNaN(value)) return '0.00';
				return Number(value).toFixed(decimals);
			},

			// ========== 数据加载 ==========
			async loadData() {
				this.loading = true;
				try {
					let params = {
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						dosform: this.filterForm.dosform,
						drugName: this.filterForm.drugName,
						storeType: this.getStoreType()
					};

					if (this.filterForm.isHaveNum !== undefined) {
						params.isHaveNum = this.filterForm.isHaveNum ? 1 : 0;
					}

					let res = await dugdpurctablePage(params);

					if (res.code === 200) {
						// shedId 赋值为 drugType
						this.tableData = res.data.content.map(item => {
							return {
								...item,
								shedId: item.drugType || 1, // 使用 drugType 作为 shedId
								pacUntCnt: (item.pacUntCnt || 0) + (item.pacUnt || 0) + (item.dosUntCnt || 0) +
									(item.dosUnt || 0),
							};
						});
						this.totalSize = res.data.totalSize;
						this.totalInventoryCount = this.calculateTotalInventoryCount(this.tableData);
						this.$emit('count-update', {
							type: this.inventoryType,
							count: this.totalInventoryCount
						});
						this.updateStatistics();
						this.$nextTick(() => {
							this.forceTableRerender();
							this.calculateTableHeight();
						});
					} else {
						this.$message.error(res.message || '获取数据失败');
						this.tableData = [];
					}
				} catch (error) {
					this.$message.error('请求出错: ' + error.message);
					this.tableData = [];
				} finally {
					this.loading = false;
				}
			},

			getStoreType() {
				const typeMap = {
					'western': '1',
					'chinese': '2',
					'western-room': '3',
					'chinese-room': '4'
				};
				return typeMap[this.inventoryType] || '1';
			},

			forceTableRerender() {
				this.tableKey = Date.now();
			},

			updateStatistics() {
				if (this.tableData.length > 0) {
					const pageStock = this.tableData.reduce((sum, item) => sum + (Number(item.purcAmt) || 0), 0);
					const totalCost = this.tableData.reduce((sum, item) => sum + parseFloat(item.saleAmt || 0), 0);
					this.currentPageTotalStock = pageStock.toLocaleString();
					this.totalCost = totalCost;
					this.totalInventoryCount = this.calculateTotalInventoryCount(this.tableData);
				} else {
					this.currentPageTotalStock = '0';
					this.totalCost = '0.00000000';
					this.totalInventoryCount = 0;
				}
			},

			calculateTotalInventoryCount(tableData) {
				if (!tableData || tableData.length === 0) return 0;
				return tableData.reduce((total, item) => {
					return total + (Number(item.realPurcCnt) || 0);
				}, 0);
			},

			// ========== 筛选与分页 ==========
			handleFilter() {
				this.pageNum = 1;
				this.loadData();
			},

			resetFilter() {
				this.filterForm = {
					drugName: '',
					dosform: '',
					dateRange: [],
					isHaveNum: true
				};
				this.pageNum = 1;
				this.loadData();
			},

			handleStockFilterChange(value) {
				console.log('库存筛选变更:', value ? '仅显示有库存' : '显示所有库存');
				this.pageNum = 1;
				this.loadData();
			},

			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.loadData();
			},

			handleCurrentChange(val) {
				this.pageNum = val;
				this.loadData();
			},

			// ========== 表格辅助方法 ==========
			getDrugTypeTagType(type) {
				const typeMap = { 1: 'success', 2: 'warning', 3: 'danger', 4: 'info', 5: 'primary' };
				return typeMap[type] || 'info';
			},

			getRowClassName({ row }) {
				if (!row || !row.drugType) return '';
				const typeMap = {
					1: 'row-drug-type-1',
					2: 'row-drug-type-2',
					3: 'row-drug-type-3',
				};
				return typeMap[row.drugType] || '';
			},

			columnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 20;
				let maxlenStr = "";
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}
				width = Math.max(width, this.len(lab), this.len(maxlenStr));
				return width + 12;

				function len(str) {
					let length = 8;
					for (const char of str + "") {
						if ("a" <= char && char <= "z") length += 12;
						else if ("A" <= char && char <= "Z") length += 8;
						else if (Number.isFinite(Number(char))) length += 8;
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 26;
						else length += 12;
					}
					return length;
				}
			},

			len(str) {
				let length = 8;
				for (const char of str + "") {
					if ("a" <= char && char <= "z") length += 8;
					else if ("A" <= char && char <= "Z") length += 8;
					else if (Number.isFinite(Number(char))) length += 8;
					else if (char >= "\u4e00" && char <= "\u9fa5") length += 18;
					else length += 12;
				}
				return length;
			},

			flowdiglogColumnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 28;
				let maxlenStr = "";
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}
				width = Math.max(width, this.len(lab), this.len(maxlenStr));
				return width + 20;
			},

			warningColumnWidth(col, list) {
				let prop = col.prop,
					lab = col.name || col.lab;
				let width = 20;
				let maxlenStr = "";
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}
				width = Math.max(width, this.len(lab), this.len(maxlenStr));
				return width + 12;
			},

			// ========== 批次明细 ==========
			async handleBatchDetail(row) {
				try {
					this.batchLoading = true;
					this.currentBatchDrug = row;
					this.currentBatchDrugName = row.drugName || '药品';

					const drugType = row.drugType !== undefined && row.drugType !== null ? row.drugType : 1;
					console.log('批次明细 - drugType:', drugType, '原始数据:', row);

					const res = await getYFBatchNumber({
						drugId: row.drugId || row.id,
						drugType: drugType,
						pageNum: this.batchPageNum,
						pageSize: this.batchPageSize
					});

					if (res.code === 200) {
						this.batchDetailData = res.data.content || res.data;
						this.batchTotalSize = res.data.totalSize || res.data.length;
						this.batchDetailVisible = true;
						this.$nextTick(() => {
							this.calculateTableHeight();
						});
					} else {
						this.$message.error(res.message || '获取批次数据失败');
					}
				} catch (error) {
					console.error('获取批次数据出错:', error);
					this.$message.error('获取批次数据出错');
				} finally {
					this.batchLoading = false;
				}
			},

			closeBatchDetail() {
				this.batchDetailVisible = false;
				this.currentBatchDrug = null;
				this.currentBatchDrugName = '';
				this.batchDetailData = [];
				this.batchPageNum = 1;
				this.batchTotalSize = 0;
				this.$nextTick(() => {
					this.calculateTableHeight();
				});
			},

			handleBatchSizeChange(val) {
				this.batchPageSize = val;
				this.batchPageNum = 1;
				if (this.currentBatchDrug) {
					this.handleBatchDetail(this.currentBatchDrug);
				}
			},

			handleBatchCurrentChange(val) {
				this.batchPageNum = val;
				if (this.currentBatchDrug) {
					this.handleBatchDetail(this.currentBatchDrug);
				}
			},

			// 批次明细操作列下拉菜单命令处理（目前仅有“效期调整”）
			handleBatchActionCommand(payload) {
				const {
					action,
					row
				} = payload || {};
				if (action === 'expiry') {
					this.handleExpiryAdjust(row);
				} else if (action === 'price') {
					this.handlePriceAdjust(row);
				}
			},

			// ========== 流向记录 ==========
			handleFlowRecord(row) {
				this.flowDialogTitle = row.drugName || '药品';
				this.flowdiglog = true;
				this.flowId = row.id || row.purcId;
				this.manuLotnum = row.manuLotnum;
				this.pageNum = 1;
				this.pageSize = 10;
				this.getFlowData();
			},

			async getFlowData() {
				if (!this.flowId) {
					this.$message.error('缺少药品ID参数');
					return;
				}
				try {
					this.loading = true;
					let params = {
						purcId: this.flowId,
						pageNum: this.pageNum,
						pageSize: this.pageSize,
					};
					let res = await dugYFChgPage(params);
					if (res.code === 200) {
						this.innertableData = res.data.content || res.data;
						this.innertableData = this.innertableData.map(item => {
							return {shedId: 2,...item};
						});
						this.innerTotolSize = res.data.totalSize || (res.data.content ? res.data.content.length : 0);
						this.$message.success('获取流向记录成功');
					} else {
						this.$message.error(res.message || '获取流向记录失败');
					}
				} catch (error) {
					console.error('获取流向记录出错:', error);
					this.$message.error('获取流向记录出错: ' + error.message);
				} finally {
					this.loading = false;
				}
			},

			innerHandleSizeChange(val) {
				this.innerPageSize = val;
				this.pageNum = 1;
				this.getFlowData();
			},

			innerHandleCurrentChange(val) {
				this.pageNum = val;
				this.getFlowData();
			},

			// ========== 价格调整 ==========
			async handlePriceAdjust(row) {
				try {
					this.loading = true;
					this.currentPriceRow = row;
					const res = await chgYFDetailsPage({
						purcId: row.id || row.purcId,
						pageNum: 1,
						pageSize: 10
					});
					if (res.code === 200) {
						const priceData = res.data.content && res.data.content.length > 0 ?
							res.data.content[0] :
							res.data;
						const extractPackageCount = (purcCntStr) => {
							if (!purcCntStr) return 1;
							const match = purcCntStr.match(/(\d+)盒/);
							if (match && match[1]) {
								return parseInt(match[1]) || 1;
							}
							const numberMatch = purcCntStr.match(/\d+/);
							return numberMatch ? parseInt(numberMatch[0]) || 1 : 1;
						};
						const packageCount = extractPackageCount(priceData.purcCnt || row.purcCnt);
						let currentPurcPric = 0;
						// 已移除销售单价相关计算
						if (priceData.purcPric) {
							currentPurcPric = Number(priceData.purcPric);
						} else if (row.purcPric) {
							currentPurcPric = Number(row.purcPric);
						}
						if (currentPurcPric === 0) {
							const purcAmt = priceData.purcAmt || row.purcAmt;
							if (purcAmt && packageCount > 0) {
								currentPurcPric = Number(purcAmt) / packageCount;
							}
						}
						// 只保留成本单价
						this.originalPrices = {
							purcPric: Number(currentPurcPric.toFixed(2))
						};
						this.priceAdjustForm = {
							drugName: row.drugName || '',
							manuLotnum: row.manuLotnum || '',
							adjustPurcPric: this.originalPrices.purcPric,
							drugId: row.drugId || row.id,
							purcId: row.id,
							purcType: 1,
							realCnt: priceData.purcCnt || row.purcCnt || '0'
						};
						this.priceAdjustVisible = true;
						this.priceChanged = false;
					} else {
						this.$message.error(res.message || '获取价格数据失败');
					}
				} catch (error) {
					console.error('获取价格数据出错:', error);
					this.$message.error('获取价格数据出错');
				} finally {
					this.loading = false;
					this.$nextTick(() => {
						if (this.$refs.priceAdjustForm) {
							this.$refs.priceAdjustForm.clearValidate();
						}
					});
				}
			},

			getPackageCount(purcCntStr) {
				if (!purcCntStr) return 1;
				const match = purcCntStr.match(/(\d+)盒/);
				if (match && match[1]) {
					return parseInt(match[1]) || 1;
				}
				const numberMatch = purcCntStr.match(/\d+/);
				return numberMatch ? parseInt(numberMatch[0]) || 1 : 1;
			},

			checkPriceChange() {
				this.priceChanged = this.isPriceChanged;
			},

			async handlePriceAdjustSubmit() {
				if (this.isNoChange) {
					this.$message.warning('价格未发生变化，请调整价格后再提交');
					return;
				}
				this.$refs.priceAdjustForm.validate(async (valid) => {
					if (valid) {
						this.loading = true;
						try {
							// 已移除 adjustSalePric 参数，仅提交成本单价
							const params = {
								adjustPurcPric: this.priceAdjustForm.adjustPurcPric,
								drugId: this.priceAdjustForm.drugId,
								purcId: this.priceAdjustForm.purcId,
								purcType: 1
							};
							const res = await adjustYFFastPric(params);
							if (res.code === 200) {
								this.$message.success('价格调整成功');
								this.priceAdjustVisible = false;
								this.loadData();
								if (this.currentBatchDrug) {
									await this.handleBatchDetail(this.currentBatchDrug);
								}
							} else {
								this.$message.error(res.message || '价格调整失败');
							}
						} catch (error) {
							console.error('价格调整出错:', error);
							this.$message.error('价格调整出错');
						} finally {
							this.loading = false;
						}
					} else {
						this.$message.error('请填写完整的价格信息');
						return false;
					}
				});
			},

			priceAdjustHandleClose(done) {
				this.$confirm('确认关闭？未保存的修改将丢失。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.priceAdjustVisible = false;
					if (done) done();
				}).catch(() => {
					this.$message.info('已取消关闭');
				});
			},

			// ========== 效期调整 ==========
			handleExpiryAdjust(row) {
				this.currentExpiryRow = row;
				this.expiryAdjustForm = {
					drugName: row.drugName || '',
					manuLotnum: row.manuLotnum || '',
					manuDate: row.manuDate || '',
					expyDate: row.expyDate || ''
				};
				this.expiryAdjustVisible = true;
			},

			async handleExpiryAdjustSubmit() {
				this.$refs.expiryAdjustForm.validate(async (valid) => {
					if (valid) {
						if (this.expiryAdjustForm.manuDate && this.expiryAdjustForm.expyDate) {
							const manuDate = new Date(this.expiryAdjustForm.manuDate);
							const expyDate = new Date(this.expiryAdjustForm.expyDate);
							if (manuDate > expyDate) {
								this.$message.error('生产日期不能晚于有效期至');
								return;
							}
						}
						this.loading = true;
						try {
							const params = {
								id: this.currentExpiryRow.id,
								manuDate: this.expiryAdjustForm.manuDate,
								expyDate: this.expiryAdjustForm.expyDate
							};
							const res = await updateDate(params);
							if (res.code === 200) {
								this.$message.success('效期调整成功');
								this.expiryAdjustVisible = false;
								if (this.currentBatchDrug) {
									await this.handleBatchDetail(this.currentBatchDrug);
								}
							} else {
								this.$message.error(res.message || '效期调整失败');
							}
						} catch (error) {
							console.error('效期调整出错:', error);
							this.$message.error('效期调整出错');
						} finally {
							this.loading = false;
						}
					} else {
						this.$message.error('请填写完整的效期信息');
					}
				});
			},

			expiryAdjustHandleClose(done) {
				this.$confirm('确认关闭？未保存的修改将丢失。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.expiryAdjustVisible = false;
					if (done) done();
				}).catch(() => {
					this.$message.info('已取消关闭');
				});
			},

			// ========== 预警相关 ==========
			async loadWarningData() {
				this.warningLoading = true;
				try {
					let params = {
						drugName: this.warningFilterForm.drugName,
						pageNum: this.warningPageNum,
						pageSize: this.warningPageSize,
					};
					let res = await alertList(params);
					if (res.code === 200) {
						this.warningTableData = res.data;
						this.warningTotalSize = res.data.totalSize || res.data.length;
					} else {
						this.$message.error(res.message || '获取预警数据失败');
						this.warningTableData = [];
					}
				} catch (error) {
					this.$message.error('请求预警数据出错: ' + error.message);
					this.warningTableData = [];
				} finally {
					this.warningLoading = false;
				}
			},

			async loadWarningEditData() {
				this.warningLoading = true;
				try {
					let params = {
						drugName: this.warningFilterForm.drugName,
						pageNum: this.warningEditPageNum,
						pageSize: this.warningEditPageSize,
					};
					let res = await alertPages(params);
					if (res.code === 200) {
						this.warningEditTableData = (res.data || []).map((item, index) => {
							return { ...item, index: index };
						});
						this.warningEditTotalSize = res.data.totalSize || res.data.length;
					} else {
						this.$message.error(res.message || '获取预警编辑数据失败');
						this.warningEditTableData = [];
					}
				} catch (error) {
					this.$message.error('请求预警编辑数据出错: ' + error.message);
					this.warningEditTableData = [];
				} finally {
					this.warningLoading = false;
				}
			},

			warningTableCellClassName({ row, column, rowIndex, columnIndex }) {
				row.index = rowIndex;
				column.index = columnIndex;
			},

			warningEditDbClick(row, column) {
				if (column.property === 'cntLow' || column.property === 'cntHigh') {
					this.warningCurrentCell = `warning_${row.index}_${column.index}`;
					this.$nextTick(() => {
						const inputRef = this.$refs[this.warningCurrentCell];
						if (inputRef && inputRef.focus) {
							inputRef.focus();
						}
					});
				} else {
					this.$message.warning('只有最低库存和最高库存允许编辑');
				}
			},

			warningEditHideInput(row) {
				this.validateWarningInput(row, 'cntLow', '最低库存');
			},

			warningEditHighHideInput(row) {
				this.validateWarningInput(row, 'cntHigh', '最高库存');
			},

			validateWarningInput(row, field, fieldName) {
				const numberRegex = /^\d+$/;
				if (!numberRegex.test(row[field])) {
					this.$message.error(`${fieldName}格式不正确! 请输入正整数`);
					return false;
				} else if (String(row[field]).length > 8) {
					this.$message.error(`${fieldName}最大长度单位为8！`);
					return false;
				}
				if (field === 'cntLow' && row.cntHigh && Number(row.cntLow) > Number(row.cntHigh)) {
					this.$message.error('最低库存数量不能大于最高库存数量！');
					return false;
				}
				if (field === 'cntHigh' && row.cntLow && Number(row.cntHigh) < Number(row.cntLow)) {
					this.$message.error('最高库存数量不能小于最低库存数量！');
					return false;
				}
				this.warningCurrentCell = null;
				this.warningSubmitData = { ...row };
				this.$message.success(`${fieldName}设置成功！`);
				return true;
			},

			async warningEditSubmit() {
				if (!this.warningSubmitData || Object.keys(this.warningSubmitData).length === 0) {
					this.$message.warning('请先设置预警数量');
					return;
				}
				this.warningLoading = true;
				try {
					let res = await alert(this.warningSubmitData);
					if (res.code === 200) {
						this.$message.success('预警设置成功！');
						this.warningEditVisible = false;
						this.loadWarningData();
					} else {
						this.$message.error(res.message || '预警设置失败');
					}
				} catch (error) {
					this.$message.error('预警设置出错: ' + error.message);
				} finally {
					this.warningLoading = false;
				}
			},

			handleSetWarning() {
				this.warningEditVisible = true;
				this.warningEditPageNum = 1;
				this.loadWarningEditData();
			},

			handleWarningRefresh() {
				this.warningPageNum = 1;
				this.loadWarningData();
			},

			handleWarningFilter() {
				this.warningPageNum = 1;
				this.loadWarningData();
			},

			handleWarningCommand(command) {
				switch (command) {
					case 'a':
						this.warningDropDownedName = '卫材';
						break;
					case 'b':
						this.warningDropDownedName = '疫苗';
						break;
					case 'c':
						this.warningDropDownedName = '中成药';
						break;
					case 'd':
						this.warningDropDownedName = '西药';
						break;
					case 'e':
						this.warningDropDownedName = '全部';
						break;
				}
				this.handleWarningFilter();
			},

			handleWarningSizeChange(val) {
				this.warningPageSize = val;
				this.warningPageNum = 1;
				this.loadWarningData();
			},

			handleWarningCurrentChange(val) {
				this.warningPageNum = val;
				this.loadWarningData();
			},

			handleWarningEditSizeChange(val) {
				this.warningEditPageSize = val;
				this.warningEditPageNum = 1;
				this.loadWarningEditData();
			},

			handleWarningEditCurrentChange(val) {
				this.warningEditPageNum = val;
				this.loadWarningEditData();
			},

			warningEditHandleClose(done) {
				this.$confirm('确认关闭？未保存的修改将丢失。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.warningEditVisible = false;
					if (done) done();
				}).catch(() => {
					this.$message.info('已取消关闭');
				});
			},

			// ========== 图表相关 ==========
			initChart() {
				const chartDom = document.getElementById('inventoryChart');
				if (!chartDom) return;
				if (this.chart) {
					this.chart.dispose();
				}
				this.chart = echarts.init(chartDom);
				window.addEventListener('resize', this.handleChartResize);
			},

			handleChartResize() {
				if (this.chart) {
					this.chart.resize();
				}
			},

			updateChart() {
				if (!this.chart || !this.tableData || this.tableData.length === 0) {
					return;
				}
				const chartData = this.prepareChartData();
				const option = this.getChartOption(chartData);
				this.chart.setOption(option, true);
				this.updateChartStats();
			},

			prepareChartData() {
				const data = this.tableData;
				let groupedData = {};
				data.forEach(item => {
					const groupKey = this.getGroupKey(item);
					if (!groupedData[groupKey]) {
						groupedData[groupKey] = {
							name: groupKey,
							value: 0,
							count: 0,
							items: []
						};
					}
					const value = Number(item[this.chartDataField]) || 0;
					groupedData[groupKey].value += value;
					groupedData[groupKey].count++;
					groupedData[groupKey].items.push(item);
				});
				return Object.values(groupedData)
					.sort((a, b) => b.value - a.value)
					.slice(0, 20);
			},

			getGroupKey(item) {
				const groupField = this.chartGroupBy;
				let key = item[groupField];
				if (groupField === 'drugType' && this.drugTypeMap[key]) {
					return this.drugTypeMap[key];
				} else if (groupField === 'dosform' && this.dosformMap[key]) {
					return this.dosformMap[key];
				} else if (groupField === 'shedId' && this.shedIdMap[key]) {
					return this.shedIdMap[key];
				}
				return key || '未知';
			},

			getChartOption(chartData) {
				const isValueChart = ['line', 'bar', 'candlestick'].includes(this.chartType);
				const baseOption = {
					title: {
						text: this.getChartTitle(),
						left: 'center',
						textStyle: {
							fontSize: 16,
							fontWeight: 'bold'
						}
					},
					tooltip: {
						trigger: isValueChart ? 'axis' : 'item',
						formatter: (params) => this.getTooltipFormatter(params)
					},
					toolbox: {
						feature: {
							saveAsImage: {
								title: '保存为图片'
							},
							dataView: {
								title: '数据视图'
							},
							restore: {
								title: '还原'
							}
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					}
				};

				switch (this.chartType) {
					case 'line':
						return {
							...baseOption,
							xAxis: {
								type: 'category',
								data: chartData.map(d => d.name),
								axisLabel: { rotate: 45 }
							},
							yAxis: {
								type: 'value',
								name: this.getYAxisName()
							},
							series: [{
								type: 'line',
								data: chartData.map(d => d.value),
								smooth: true,
								itemStyle: { color: '#5470c6' },
								areaStyle: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: 'rgba(84, 112, 198, 0.5)'
										},
										{
											offset: 1,
											color: 'rgba(84, 112, 198, 0.1)'
										}
									])
								}
							}]
						};
					case 'bar':
						return {
							...baseOption,
							xAxis: {
								type: 'category',
								data: chartData.map(d => d.name),
								axisLabel: { rotate: 45 }
							},
							yAxis: {
								type: 'value',
								name: this.getYAxisName()
							},
							series: [{
								type: 'bar',
								data: chartData.map(d => d.value),
								itemStyle: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: '#83bff6'
										},
										{
											offset: 0.5,
											color: '#188df0'
										},
										{
											offset: 1,
											color: '#188df0'
										}
									])
								}
							}]
						};
					case 'pie':
						return {
							...baseOption,
							series: [{
								type: 'pie',
								data: chartData.map(d => ({
									name: d.name,
									value: d.value
								})),
								radius: ['40%', '70%'],
								itemStyle: {
									borderRadius: 10,
									borderColor: '#fff',
									borderWidth: 2
								},
								label: {
									formatter: '{b}: {c} ({d}%)'
								}
							}]
						};
					case 'treemap':
						return {
							...baseOption,
							series: [{
								type: 'treemap',
								data: chartData.map(d => ({
									name: d.name,
									value: d.value
								})),
								upperLabel: {
									show: true,
									height: 30
								},
								itemStyle: {
									borderColor: '#fff'
								}
							}]
						};
					case 'candlestick':
						const candleData = this.generateCandleData(chartData);
						return {
							...baseOption,
							xAxis: {
								type: 'category',
								data: candleData.categories,
								boundaryGap: false,
								axisLine: { onZero: false },
								splitLine: { show: false },
								min: 'dataMin',
								max: 'dataMax'
							},
							yAxis: {
								type: 'value',
								scale: true,
								splitArea: { show: true }
							},
							series: [{
								type: 'candlestick',
								data: candleData.values,
								itemStyle: {
									color: '#ec0000',
									color0: '#00da3c',
									borderColor: '#8A0000',
									borderColor0: '#008F28'
								}
							}]
						};
					default:
						return baseOption;
				}
			},

			generateCandleData(chartData) {
				const categories = chartData.map(d => d.name);
				const values = chartData.map(d => {
					const baseValue = d.value;
					const open = baseValue;
					const close = baseValue * (0.9 + Math.random() * 0.2);
					const low = Math.min(open, close) * (0.8 + Math.random() * 0.1);
					const high = Math.max(open, close) * (1.1 + Math.random() * 0.1);
					return [open, close, low, high];
				});
				return { categories, values };
			},

			getChartTitle() {
				const fieldMap = {
					'purcCnt': '库存数量',
					'purcAmt': '成本金额',
					'saleAmt': '零售金额',
					'drugType': '药品类型'
				};
				const groupMap = {
					'drugType': '药品类型',
					'shedId': '库房',
					'dosform': '剂型'
				};
				return `${fieldMap[this.chartDataField]}分布 - 按${groupMap[this.chartGroupBy]}分组`;
			},

			getYAxisName() {
				const fieldMap = {
					'purcCnt': '数量',
					'purcAmt': '金额(元)',
					'saleAmt': '金额(元)',
					'drugType': '计数'
				};
				return fieldMap[this.chartDataField] || '';
			},

			getTooltipFormatter(params) {
				if (this.chartType === 'pie' || this.chartType === 'treemap') {
					const data = params.data;
					return `${data.name}: ${data.value}<br/>占比: ${params.percent}%`;
				} else {
					return `${params[0].name}: ${params[0].value}`;
				}
			},

			updateChartStats() {
				const data = this.tableData;
				this.chartStats = {
					totalDrugs: data.length,
					totalStock: data.reduce((sum, item) => sum + (Number(item.purcCnt) || 0), 0),
					totalCost: data.reduce((sum, item) => sum + (Number(item.purcAmt) || 0), 0),
					avgStock: data.length > 0 ?
						Math.round(data.reduce((sum, item) => sum + (Number(item.purcCnt) || 0), 0) / data.length) : 0
				};
			},

			refreshChart() {
				this.updateChart();
			},

			downloadChart() {
				if (this.chart) {
					const url = this.chart.getDataURL({
						type: 'png',
						pixelRatio: 2,
						backgroundColor: '#fff'
					});
					const link = document.createElement('a');
					link.href = url;
					link.download = `库存分析图表_${new Date().toISOString().slice(0, 10)}.png`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
			},

			// ========== 其他辅助方法 ==========
			getDateTime() {
				const today = new Date();
				const startDate = new Date(today);
				startDate.setHours(0, 0, 0, 0);
				this.startDate = this.formatDateTime(startDate);
				const endDate = new Date(today);
				endDate.setHours(23, 59, 59, 999);
				this.endDate = this.formatDateTime(endDate);
			},

			formatDateTime(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},

			handleStatsTabClick(tab) {
				console.log('切换到统计信息标签:', tab.name);
			},

			handledbRow(row, column, event) {
				// 双击行事件
			},

			handleCurrentTableChange(val) {
				this.currentTable = val;
			},

			changeData() {
				this.getFlowData();
			},

			flowhandleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => { done(); })
					.catch(_ => {});
			},

			dy() {
				const printData = this.planMedicalRecord();
				if (printData) {
					printUtil.init(Winvent);
					printUtil.print(printData);
				}
			},

			planMedicalRecord() {
				if (!this.innertableData || this.innertableData.length === 0) {
					this.$message.warning('没有可打印的流向记录数据');
					return null;
				}
				const formatCurrentTime = () => {
					const now = new Date();
					const year = now.getFullYear();
					const month = String(now.getMonth() + 1).padStart(2, '0');
					const day = String(now.getDate()).padStart(2, '0');
					const hours = String(now.getHours()).padStart(2, '0');
					const minutes = String(now.getMinutes()).padStart(2, '0');
					const seconds = String(now.getSeconds()).padStart(2, '0');
					return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				};
				const printData = {
					flowDialogTitle: this.flowDialogTitle || '药品流向记录',
					nowDateTime: formatCurrentTime(),
					tableData: this.innertableData.map((item, index) => ({
						rowNum: index + 1,
						sysNum: item.id || '',
						drugName: item.drugName || this.flowDialogTitle || '',
						storage: this.shedIdMap[item.shedId] || '未知',
						source: this.bizMap[item.bizSouc] || '未知',
						changeQty: item.chgCnt || 0,
						beforeQty: item.agoCnt || 0,
						afterQty: item.afrCnt || 0,
						unt: item.unt || '',
						purcPric: item.purcPric || 0,
						salePric: item.salePric || 0,
						drugSpec: item.drugSpec || '',
						prodentpName: item.prodentpName || '',
						manuLotnum: item.manuLotnum || ''
					})),
					businessDate: `${this.startDate} 至 ${this.endDate}`,
					operator: this.userInfo?.userName || '未知',
					reviewer: '系统审核'
				};
				return printData;
			},

			startDateHandle(value) {
				if (value) {
					this.startTime = value;
				} else {
					this.startTime = '';
				}
			},

			endDateHandle(value) {
				if (value) {
					this.endTime = value;
				} else {
					this.endTime = '';
				}
			},

			handClick(i) {
				switch (i) {
					case 0:
						this.loading = true;
						setTimeout(() => {
							this.loadData();
							this.$message({ type: 'success', message: '已刷新' });
							this.loading = false;
						}, 1500);
						break;
					case 1:
						this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						break;
				}
			},

			TZXQhandleCurrent(val) {
				if (val) {
					this.TZXQcurrentTable = { ...val };
					this.flowId = val.drugId;
					this.manuLotnum = val.manuLotnum;
				} else {
					this.TZXQcurrentTable = {};
				}
			},

			feetHandClick(i) {
				switch (i) {
					case 0:
						if (!this.currentTable || Object.keys(this.currentTable).length === 0) {
							this.$message.warning('请先选择一条数据');
							return;
						}
						this.$nextTick(() => {
							const table = this.$refs.singleTable;
							if (table) {
								table.setCurrentRow(this.currentTable);
							}
						});
						this.getBatchNumberData();
						break;
					case 1:
						this.$message({ type: 'warning', message: '流向记录' });
						break;
					case 2:
						break;
					case 3:
						this.$message({ type: 'warning', message: '暂未开放，敬请期待。' });
						break;
				}
			},

			XQfeetHandClick(v) {
				if (v.title == '档案信息' || v.title.includes('档案信息')) {
					this.$message({ type: 'warning', message: '档案信息' });
				} else if (v.title == '流向记录' || v.title.includes('流向记录')) {
					if (!this.TZXQcurrentTable || Object.keys(this.TZXQcurrentTable).length === 0) {
						this.$message.warning('请先选择一条批次数据');
						return;
					}
					this.manuLotnum = this.TZXQcurrentTable.manuLotnum;
					this.flowId = this.TZXQcurrentTable.id;
					this.flowDialogTitle = this.TZXQcurrentTable.drugName;
					this.flowdiglog = true;
					this.getFlowData();
				} else if (v.title == '日期调整' || v.title.includes('日期调整')) {
					if (!this.TZXQcurrentTable || Object.keys(this.TZXQcurrentTable).length === 0) {
						this.$message.warning('请先选择一条批次数据');
						return;
					}
					this.TZXQdialogVisible = true;
				} else if (v.title == '打印' || v.title.includes('打印')) {
					if (!this.innertableData || this.innertableData.length === 0) {
						this.$message.warning('没有可打印的流向记录数据');
						return;
					}
					this.handlePrint();
				} else if (v.title == '关闭' || v.title.includes('关闭')) {
					this.XQdialogVisible = false;
				}
			},

			async handlePrint() {
				if (!this.innertableData || this.innertableData.length === 0) {
					this.$message.warning('没有可打印的流向记录数据');
					return;
				}
				this.$confirm('请选择打印方式', '打印设置', {
					confirmButtonText: 'Lodop打印',
					cancelButtonText: '浏览器打印',
					type: 'warning'
				}).then(() => {
					const printData = this.planMedicalRecord();
					if (printData) {
						printUtil.init(Winvent);
						printUtil.print(printData);
					}
				}).catch(() => {
					const printData = this.planMedicalRecord();
					if (printData) {
						printUtil.init(Winvent);
						printUtil.preview(printData);
					}
				});
			},

			printWithLodop() {
				const tableData = this.tableData.map(item => ({ ...item }));
				this.$router.push({
					path: '/PrintTemplateDesigner',
					query: {
						tableData: JSON.stringify(tableData),
						currentTable: JSON.stringify(tableData),
						templateName: '【西药库】药品库存清单'
					}
				});
			},

			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						this.$refs['addForm'].resetFields();
						done();
					})
					.catch(_ => {});
			},

			XQhandleClose(done) {
				this.$confirm('确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.XQtableData = [];
					this.TZXQcurrentTable = {};
					this.XQdialogVisible = false;
					if (done) done();
				}).catch(() => {
					this.$message.info('已取消关闭');
				});
			},

			TZXQhandleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => { done(); })
					.catch(_ => {});
			},

			handleManuDateChange(value) {
				if (!value) return;
				if (this.TZXQcurrentTable.expyDate &&
					new Date(value) > new Date(this.TZXQcurrentTable.expyDate)) {
					this.$message.warning('生产日期不能晚于有效日期');
					this.TZXQcurrentTable.manuDate = '';
				}
			},

			handleExpyDateChange(value) {
				if (!value) return;
				const currentDate = new Date();
				const manuDate = this.TZXQcurrentTable.manuDate ? new Date(this.TZXQcurrentTable.manuDate) : null;
				if (new Date(value) < currentDate) {
					this.$message.warning('有效日期不能早于当前日期');
					this.TZXQcurrentTable.expyDate = '';
					return;
				}
				if (manuDate && new Date(value) < manuDate) {
					this.$message.warning('有效日期不能早于生产日期');
					this.TZXQcurrentTable.expyDate = '';
				}
			},

			handleCommand(command) {
				switch (command) {
					case 'a':
						this.DropDownedName = '可用';
						break;
					case 'b':
						this.DropDownedName = '禁用';
						break;
					case 'c':
						this.DropDownedName = '全部';
						break;
				}
			},

			updateWindowWidth() {
				this.windowWidth = window.innerWidth - 228;
			},

			async getBatchNumberData() {
				if (!this.currentTable || Object.keys(this.currentTable).length === 0) {
					this.$message.warning('请先选择一条数据');
					return;
				}
				try {
					this.loading = true;
					const row = this.currentTable;
					const drugType = row.drugType !== undefined && row.drugType !== null ? row.drugType : 1;
					const res = await getYFBatchNumber({
						drugId: row.drugId || row.id,
						drugType: drugType,
						pageNum: this.batchPageNum,
						pageSize: this.batchPageSize
					});
					if (res.code === 200) {
						this.batchDetailData = res.data;
						this.batchDetailVisible = true;
						this.currentBatchDrugName = row.drugName || '药品';
						this.$nextTick(() => {
							this.calculateTableHeight();
						});
					} else {
						this.$message.error(res.message || '获取批次号数据失败');
					}
				} catch (error) {
					console.error('获取批次号数据出错:', error);
					this.$message.error('获取批次号数据出错');
				} finally {
					this.loading = false;
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	/* ===== 全局容器 ===== */
	.xyk-container {
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 20px 0 20px;
		box-sizing: border-box;
		overflow: hidden;
		background: #f0f2f5;
	}

	/* ===== 筛选条件区域 ===== */
	.filter-section {
		flex-shrink: 0;
		background: #ffffff;
		padding: 10px 16px;
		border-radius: 8px;
		margin-bottom: 10px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

		.filter-form {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 4px 0;

			.el-form-item {
				margin-bottom: 0;
				margin-right: 12px;
			}
		}
	}

	/* ===== 统计信息区域 ===== */
	.stats-section {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		min-height: 0;

		.stats-tabs {
			flex: 1;
			display: flex;
			flex-direction: column;
			overflow: hidden;
			border-radius: 8px;
			background: #ffffff;
			box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

			.el-tabs__header {
				margin: 0;
				flex-shrink: 0;
				background: #fafbfc;
				border-bottom: 1px solid #e4e7ed;
				border-radius: 8px 8px 0 0;
				padding: 0 !important;
			}

			.el-tabs__item {
				height: 40px;
				line-height: 40px;
				font-size: 14px;
			}

			.el-tabs__content {
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				padding: 0;
			}

			.el-tab-pane {
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				height: 100%;
			}
		}
	}

	/* ===== 内容区域 ===== */
	.stats-content {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		padding: 10px 16px 0 16px;
	}

	/* ===== 表格容器包装器（主表格 + 覆盖式批次表格） ===== */
	.table-container-wrapper {
		flex: 1;
		display: flex;
		overflow: hidden;
		position: relative;
	}

	/* ===== 主表格区域 ===== */
	.main-table-section {
		flex: 1;
		width: 100%;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		.table-section {
			flex: 1;
			display: flex;
			flex-direction: column;
			overflow: hidden;
			background: #ffffff;
			border-radius: 6px;
			border: 1px solid #ebeef5;

			.table-container {
				flex: 1;
				overflow: hidden;
				padding: 0 2px;
				position: relative;

				.el-table {
					/* ===== 行高统一 28px ===== */
					.el-table__header-wrapper {
						.el-table__row {
							height: 28px !important;
							min-height: 28px !important;

							th {
								padding: 0 !important;
								height: 28px !important;
								.cell {
									line-height: 26px !important;
									padding: 0 8px !important;
									font-size: 13px !important;
									font-weight: normal !important;
								}
							}
						}
					}

					.el-table__body-wrapper {
						overflow-y: auto !important;
						overflow-x: auto !important;

						.el-table__row {
							height: 28px !important;
							min-height: 28px !important;

							td {
								padding: 0 !important;
								height: 28px !important;
								.cell {
									line-height: 26px !important;
									padding: 0 8px !important;
									font-size: 13px !important;
									font-weight: normal !important;
								}
							}
						}
					}

					/* ===== 根据 drugType 显示行背景色 ===== */
					::v-deep .el-table__row.row-drug-type-1 {
						background-color: #dfe6e4 !important;
					}
					::v-deep .el-table__row.row-drug-type-2 {
						background-color: #fff4e6 !important;
					}
					::v-deep .el-table__row.row-drug-type-3 {
						background-color: #ffeff1 !important;
					}
					::v-deep .el-table__row.row-drug-type-1:hover td {
						background-color: #dfe6e4 !important;
					}
					::v-deep .el-table__row.row-drug-type-2:hover td {
						background-color: #fff4e6 !important;
					}
					::v-deep .el-table__row.row-drug-type-3:hover td {
						background-color: #ffeff1 !important;
					}
					::v-deep .el-table__row.row-drug-type-1.current-row td {
						background-color: #dfe6e4 !important;
					}
					::v-deep .el-table__row.row-drug-type-2.current-row td {
						background-color: #fff4e6 !important;
					}
					::v-deep .el-table__row.row-drug-type-3.current-row td {
						background-color: #ffeff1 !important;
					}
				}
			}

			.pagination-section {
				flex-shrink: 0;
				padding: 6px 16px;
				border-top: 1px solid #ebeef5;
				background: #fafbfc;
				display: flex;
				justify-content: flex-end;

				.el-pagination {
					padding: 4px 0;
				}
			}
		}
	}

	/* ===== 批次表格区域（绝对定位覆盖主表格，仅位移动画，无透明度/模糊） ===== */
	.batch-table-section {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: #ffffff;
		border-radius: 6px;
		border: 1px solid #ebeef5;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		box-shadow: -6px 0 24px rgba(0, 0, 0, 0.08);
		transform: translateX(102%);
		will-change: transform;
		transition: transform 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
		z-index: 10;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;

		&.expanded {
			transform: translateX(0);
		}

		/* ===== 圆形右箭头：位于最左侧、竖向 Y 轴正中间，点击向右缓慢滑出关闭 ===== */
		.batch-toggle-btn {
			position: absolute;
			left: 8px;
			top: 50%;
			transform: translateY(-50%);
			width: 36px;
			height: 36px;
			border-radius: 50%;
			background: linear-gradient(135deg, #409EFF 0%, #1a6be0 100%);
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			box-shadow: 0 4px 14px rgba(64, 158, 255, 0.45);
			transition: box-shadow 0.3s ease, background 0.3s ease;
			z-index: 30;
			user-select: none;

			i {
				font-size: 18px;
				font-weight: bold;
			}

			&:hover {
				background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
				box-shadow: 0 6px 20px rgba(64, 158, 255, 0.7);
			}

			&:active {
				background: #1a6be0;
			}
		}

		.batch-table-header {
			flex-shrink: 0;
			padding: 6px 16px;
			border-bottom: 1px solid #ebeef5;
			background: #fafbfc;
			min-height: 32px;

			.batch-table-title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				span {
					font-size: 13px;
					font-weight: 600;
					color: #303133;
				}
			}
		}

		.batch-table-container {
			flex: 1;
			overflow: hidden;
			padding: 0 2px;
			position: relative;

			.el-table {
				.el-table__body-wrapper {
					overflow-y: auto !important;
					overflow-x: auto !important;
				}

				.el-table__header-wrapper {
					.el-table__row {
						height: 28px !important;
						min-height: 28px !important;

						th {
							padding: 0 !important;
							height: 28px !important;
							.cell {
								line-height: 26px !important;
								padding: 0 8px !important;
								font-size: 13px !important;
								font-weight: normal !important;
							}
						}
					}
				}

				.el-table__body-wrapper {
					.el-table__row {
						height: 28px !important;
						min-height: 28px !important;

						td {
							padding: 0 !important;
							height: 28px !important;
							.cell {
								line-height: 26px !important;
								padding: 0 8px !important;
								font-size: 13px !important;
								font-weight: normal !important;
							}
						}
					}
				}

				/* 批次表格行背景色 */
				::v-deep .el-table__row.row-drug-type-1 {
					background-color: #c8e6c9 !important;
				}
				::v-deep .el-table__row.row-drug-type-2 {
					background-color: #fff4e6 !important;
				}
				::v-deep .el-table__row.row-drug-type-3 {
					background-color: #ffeff1 !important;
				}
				::v-deep .el-table__row.row-drug-type-1:hover td { background-color: #a5d6a7 !important; }
				::v-deep .el-table__row.row-drug-type-2:hover td { background-color: #ffcc80 !important; }
				::v-deep .el-table__row.row-drug-type-3:hover td { background-color: #ef9a9a !important; }
				::v-deep .el-table__row.row-drug-type-1.current-row td { background-color: #dfe6e4 !important; }
				::v-deep .el-table__row.row-drug-type-2.current-row td { background-color: #ffb74d !important; }
				::v-deep .el-table__row.row-drug-type-3.current-row td { background-color: #e57373 !important; }
			}
		}

		.batch-pagination-section {
			flex-shrink: 0;
			padding: 6px 16px;
			border-top: 1px solid #ebeef5;
			background: #fafbfc;
			display: flex;
			justify-content: flex-end;

			.el-pagination {
				padding: 2px 0;
			}
		}
	}

	/* ===== 按钮样式 ===== */
	.price-adjust-btn,
	.expiry-adjust-btn {
		margin-left: 2px;
		margin-right: 2px;
		padding: 4px 6px !important;
	}

	/* ===== 对话框样式 ===== */
	/deep/ .el-dialog {
		max-height: 90vh;
		display: flex;
		flex-direction: column;

		.el-dialog__body {
			flex: 1;
			overflow-y: auto;
			padding: 20px;
		}

		.el-dialog__header {
			background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
			padding: 10px 20px;
			border-bottom: 1px solid #e6e6e6;
			.el-dialog__title {
				color: #fff;
				font-size: 16px;
				font-weight: bold;
			}
		}

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
			&:hover {
				color: #f80000;
			}
		}
	}

	/* ===== 价格调整对话框 ===== */
	.price-adjust-dialog .el-dialog__body {
		padding: 20px;
	}
	.price-adjust-form .el-form-item {
		margin-bottom: 16px;
	}
	.price-adjust-form .el-input-number {
		width: 100%;
	}

	/* ===== 滚动条美化 ===== */
	.table-container ::-webkit-scrollbar,
	.batch-table-container ::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}
	.table-container ::-webkit-scrollbar-track,
	.batch-table-container ::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}
	.table-container ::-webkit-scrollbar-thumb,
	.batch-table-container ::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;
		&:hover {
			background: #a8a8a8;
		}
	}

	/* ===== 图表相关 ===== */
	.chart-container {
		flex: 1;
		min-height: 350px;
		padding: 12px 0;
	}
	.chart-stats {
		flex-shrink: 0;
		padding: 8px 0;
		.stat-card {
			background: #f5f7fa;
			border-radius: 6px;
			padding: 10px 16px;
			text-align: center;
			.stat-title {
				font-size: 12px;
				color: #909399;
			}
			.stat-value {
				font-size: 18px;
				font-weight: 600;
				color: #303133;
				margin-top: 2px;
			}
		}
	}

	/* ===== 预警筛选 ===== */
	.warning-filter {
		flex-shrink: 0;
		padding: 6px 0;
		.el-form {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 4px 0;
			.el-form-item {
				margin-bottom: 0;
				margin-right: 12px;
			}
		}
		.warning-buttons {
			display: flex;
			gap: 6px;
		}
		.el-dropdown-link {
			cursor: pointer;
			color: #409EFF;
			font-size: 13px;
			.el-icon-down {
				margin-left: 4px;
			}
		}
	}

	/* ===== 流向记录对话框 ===== */
	.flow-dialog {
		.dialog-header {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: 8px;
			margin-bottom: 10px;
			padding: 6px 0;
			border-bottom: 1px solid #ebeef5;
		}
		.dialog-table {
			flex: 1;
			overflow: hidden;
		}
		.dialog-pagination {
			flex-shrink: 0;
			padding-top: 10px;
			display: flex;
			justify-content: flex-end;
		}
		.el-table__row {
			height: 28px !important;
			min-height: 28px !important;
			td {
				padding: 0 !important;
				height: 28px !important;
				.cell {
					line-height: 26px !important;
					padding: 0 8px !important;
					font-size: 13px !important;
					font-weight: normal !important;
				}
			}
		}
		.el-table__header-wrapper .el-table__row th {
			height: 28px !important;
			padding: 0 !important;
			.cell {
				line-height: 26px !important;
				font-size: 13px !important;
				font-weight: normal !important;
			}
		}
		/* 流向记录对话框行背景色 */
		::v-deep .el-table__row.row-drug-type-1 {
			background-color: #c8e6c9 !important;
		}
		::v-deep .el-table__row.row-drug-type-2 {
			background-color: #fff4e6 !important;
		}
		::v-deep .el-table__row.row-drug-type-3 {
			background-color: #ffeff1 !important;
		}
		::v-deep .el-table__row.row-drug-type-1:hover td { background-color: #a5d6a7 !important; }
		::v-deep .el-table__row.row-drug-type-2:hover td { background-color: #ffcc80 !important; }
		::v-deep .el-table__row.row-drug-type-3:hover td { background-color: #ef9a9a !important; }
	}

	/* ===== 预警编辑对话框 ===== */
	.warning-edit-dialog {
		.warning-edit-table {
			flex: 1;
			overflow: hidden;
		}
		.warning-edit-pagination {
			flex-shrink: 0;
			padding-top: 10px;
			display: flex;
			justify-content: flex-end;
		}
		.el-table__row {
			height: 28px !important;
			min-height: 28px !important;
			td {
				padding: 0 !important;
				height: 28px !important;
				.cell {
					line-height: 26px !important;
					padding: 0 8px !important;
					font-size: 13px !important;
					font-weight: normal !important;
				}
			}
		}
		.el-table__header-wrapper .el-table__row th {
			height: 28px !important;
			padding: 0 !important;
			.cell {
				line-height: 26px !important;
				font-size: 13px !important;
				font-weight: normal !important;
			}
		}
		/* 预警编辑对话框行背景色 */
		::v-deep .el-table__row.row-drug-type-1 {
			background-color: #c8e6c9 !important;
		}
		::v-deep .el-table__row.row-drug-type-2 {
			background-color: #fff4e6 !important;
		}
		::v-deep .el-table__row.row-drug-type-3 {
			background-color: #ffeff1 !important;
		}
		::v-deep .el-table__row.row-drug-type-1:hover td { background-color: #a5d6a7 !important; }
		::v-deep .el-table__row.row-drug-type-2:hover td { background-color: #ffcc80 !important; }
		::v-deep .el-table__row.row-drug-type-3:hover td { background-color: #ef9a9a !important; }
	}

	/* ===== 原有 .compact-row 样式覆盖为 28px ===== */
	.el-table .compact-row {
		height: 28px !important;
		min-height: 28px !important;

		td {
			padding: 0 !important;
			height: 28px !important;
		}

		.cell {
			line-height: 26px !important;
			padding: 0 8px !important;
			font-size: 13px !important;
			font-weight: normal !important;
		}

		.el-button--mini {
			padding: 2px 8px !important;
			font-size: 12px !important;
			height: 22px !important;
			line-height: 14px !important;
		}

		.el-tag--mini {
			padding: 0 6px !important;
			height: 18px !important;
			line-height: 18px !important;
			font-size: 12px !important;
		}

		.el-input--mini {
			.el-input__inner {
				height: 22px !important;
				line-height: 22px !important;
				padding: 0 4px !important;
				font-size: 12px !important;
			}
		}
	}

	/* ===== 响应式 ===== */
	@media screen and (max-width: 768px) {
		.xyk-container {
			padding: 8px 10px 0 10px;
		}
		.filter-section .filter-form {
			.el-form-item {
				margin-right: 6px;
				.el-input,
				.el-select {
					width: 120px !important;
				}
			}
		}
		.stats-content {
			padding: 6px 6px 0 6px;
		}
	}
</style>